import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cf0aab81-969a-4e9c-9793-f40790513670/artifacts/8sw178l3_LOGO_CLICQCONSULT.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section py-16 md:py-24" data-testid="main-footer">
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Logo centré */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12">

          <img
            src={LOGO_URL}
            alt="CLICQCONSULT"
            className="w-auto mx-auto mb-6"
            style={{ height: '6rem' }} />

          <p className="text-[#FDFBF7]/60 text-sm leading-relaxed max-w-md mx-auto">
            Family Office spécialisé dans l'accompagnement patrimonial 
            franco-belge depuis plus de dix ans.
          </p>
        </motion.div>

        {/* Navigation centrée et symétrique */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-center mb-12">

          <nav className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            <Link to="/" className="text-[#FDFBF7]/60 hover:text-[#C5A059] transition-colors text-xs tracking-[0.15em] uppercase">
              Accueil
            </Link>
            <Link to="/about" className="text-[#FDFBF7]/60 hover:text-[#C5A059] transition-colors text-xs tracking-[0.15em] uppercase">
              À propos
            </Link>
            <Link to="/services" className="text-[#FDFBF7]/60 hover:text-[#C5A059] transition-colors text-xs tracking-[0.15em] uppercase">
              Services
            </Link>
            <Link to="/contact" className="text-[#FDFBF7]/60 hover:text-[#C5A059] transition-colors text-xs tracking-[0.15em] uppercase">
              Contact
            </Link>
          </nav>
        </motion.div>

        {/* Ligne décorative */}
        <div className="w-16 h-px bg-[#C5A059]/30 mx-auto mb-12" />

        {/* Informations légales centrées */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-center space-y-4">

          <div className="flex flex-wrap items-center justify-center gap-6 text-[#FDFBF7]/40 text-xs">
            <Link to="/mentions-legales" className="hover:text-[#C5A059] transition-colors">Mentions légales</Link>
            <span className="hidden md:inline">·</span>
            <span>Politique de confidentialité</span>
          </div>
          
          <p className="text-xs text-center text-[#FDFBF7]/40">
            CLICQCONSULT SRL · RPM TOURNAI · TVA BE0544664797
          </p>
          
          <p className="text-xs text-center text-[#FDFBF7]/40">
            12, Avenue de Maire · 7500 Tournai · Belgique
          </p>
          
          <p className="text-[#FDFBF7]/30 text-xs tracking-wide pt-4">
            © {currentYear} CLICQCONSULT. Tous droits réservés.
          </p>
        </motion.div>
      </div>
    </footer>);

};